import { render, staticRenderFns } from "./LimitNumber.vue?vue&type=template&id=7b95ec70&"
import script from "./LimitNumber.vue?vue&type=script&lang=js&"
export * from "./LimitNumber.vue?vue&type=script&lang=js&"
import style0 from "./LimitNumber.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports